import { types, onSnapshot, getEnv, flow, getRoot } from "mobx-state-tree";
import * as R from "ramda";

export const MapListingPinModel = types.model("MapListingPinModel").props({
  id: types.optional(types.number, 0),
  latitude: types.maybeNull(types.number, 0),
  longitude: types.maybeNull(types.number, 0)
});
